<template>
    <div>
        <div class="search-top">
            <span>年份</span>
            <el-select class="top-choose" v-model="year" @change="search()">
                <el-option v-for="item in bonusYearOptions" :key="item" :value="item" >
                </el-option>
            </el-select>
            <!-- <span>周期</span>
            <el-select class="top-choose" v-model="search.cycle">
                <el-option v-for="item in cycle_list" :key="item" :value="item" >
                </el-option>
            </el-select>
            <div class="back-btn blue" @click="searchClick">查询</div> -->
        </div>

        <div class="back-list search">
            <div class="list-head">
                <div>结算周期</div>
                <div>结算单生成日期</div>
                <div>结算单确认日期</div>
                <div>详情</div>
            </div>
            <z-scrollDiv class="main">
                <div v-for="(item,index) in dataList" :key="item.cycle_id">
                    <div class="list-item" >
                        <div>{{ item.cycle_name }}</div>
                        <div>{{ item.created_at }}</div>
                        <div>{{ item.confirm_time || "————" }}</div>
                        <div>
                            <span @click="showBill(item,index)">{{ bill_index === index?"收起":"展开" }}</span>
                        </div>
                    </div>
                    <transition name="fade">
                        <bill v-show="bill_index === index" :data="bill_data"></bill>
                    </transition>
                </div>
                <z-noData :list="dataList"></z-noData>
            </z-scrollDiv>
        </div>

        <el-pagination
            @current-change="search"
            :current-page.sync="data.current_page"
            :total="data.total"
            :page-size="data.per_page"
            layout="prev, pager, next, jumper"
        ></el-pagination>


    </div>
</template>

<script>
    import bill from 'src/components/bill.vue'

    import { mapGetters } from 'vuex';

    export default {
        components:{
            bill,
        },
        props:['index','id'],
        data(){
            return {
                year:"",
                data:{},
                bill_data:{},
                bill_index:"",
            }
        },
        computed:{
            ...mapGetters(['bonusYearOptions']),
            dataList(){
                return this.data.list;
            },
        },

        created(){
            this.fresh(this.index);
        },

        watch:{
            index(val){
                this.fresh(val);
            },
            dataList(arr){
                this.bill_handle = arr.map(item=>false);
            },
        },
        methods:{
            fresh(index){
                if(index == 1){
                    this.search(this.data.current_page);
                }
            },
            search(page){  //查询
                let obj = {
                    page:page,
                    user_id:this.id,
                    year:this.year
                }
                this.getData(obj);
            },
            getData(obj={}){
                this.$func.getBonusCycle(list=>{
                    if(!obj.year){
                        this.year = list.pop().cycle_year
                        obj.year = this.year;
                        return;  //this.year改变会触发search函数
                    }
                    let url = `api/admin/user/personal/summarylist`;
                    this.$http.get(url,{params:obj}).then(res=>{
                        if(res.status == 200){
                            this.data = res.res_data;
                        }
                    })
                });
            },

            showBill(item,index){  //获取账单
                if(this.bill_index === index){
                    this.bill_index = '';
                }else{
                    // let url =`api/admin/user/personal/detaillist`;
                    let url =`api/admin/curr_personal_detail/${item.id}`;
                    this.$http.get(url,{
                        params:{
                            // user_id:this.id,
                            cycle_detail_id:item.cycle_id,
                        }
                    }).then(res=>{
                        if(res.status ==200){
                            this.bill_data = res.res_data;
                            this.bill_index = index;
                        }
                    })
                }
            },  

        },
    }
</script>

<style lang="less" scoped>
    @import "~src/assets/less/backless/var.less";

    .list-head,.list-item{
        >div:nth-of-type(1){
            width: 20%;
        }
        >div:nth-of-type(2){
            width: 30%;
        }
        >div:nth-of-type(3){
            width: 30%;
        }

        >div:last-of-type{
            width: 20%;
            span{
                color:@blue;
                cursor: pointer;
            }
        }
        .add{
            color:#34b96c;
            // color:#43a2ff;
        }
        .reduce{
            color:#ff8383;
        }
    }
</style>





// WEBPACK FOOTER //
// person-settle.vue?3bec3c1d